/**
 * Form Messages Module
 * Handles success/error message display with auto-dismiss and animations
 */

/**
 * Initialize form message handling
 */
export const initFormMessages = () => {
    const messages = document.querySelectorAll('.form-message');

    if (messages.length === 0) {
        return;
    }

    messages.forEach(message => {
        // Add close button functionality
        const closeBtn = message.querySelector('.message-close');
        if (closeBtn) {
            closeBtn.addEventListener('click', () => {
                dismissMessage(message);
            });
        }

        // Auto-dismiss messages after 8 seconds
        setTimeout(() => {
            if (message.parentElement) {
                dismissMessage(message);
            }
        }, 8000);

        // Scroll to message on page load (smooth scroll to show the message)
        setTimeout(() => {
            const headerHeight = document.querySelector('#secondaryMenu')?.offsetHeight || 0;
            const messageTop = message.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;

            // Only scroll if message is not already in view
            if (messageTop < window.pageYOffset || messageTop > window.pageYOffset + window.innerHeight) {
                window.scrollTo({
                    top: messageTop,
                    behavior: 'smooth'
                });
            }
        }, 100);
    });
};

/**
 * Dismiss a form message with animation
 */
const dismissMessage = (messageElement) => {
    if (!messageElement) return;

    // Add fade out animation
    messageElement.style.transition = 'opacity 0.3s ease-out, transform 0.3s ease-out';
    messageElement.style.opacity = '0';
    messageElement.style.transform = 'translateY(-20px)';

    // Remove element after animation completes
    setTimeout(() => {
        messageElement.remove();
    }, 300);
};
